module.exports = __webpack_public_path__ + "static/media/accesoriosHombre.b543078c.png";